import { useDispatch } from 'react-redux';

import axiosPrivate from 'config/axiosPrivate';

import { updateForm, updateTextForm } from 'store/Admin/Analyser';
import { updateTextOfTextList } from 'store/Admin/OrderDisplay';

export const useAdminInvalidateText = ({
  t,
  textId,
  setErrorSuccessMsg,
  setIsSuccess,
  setErrorSuccess,
  setIsFetchLoading,
}) => {
  const dispatch = useDispatch();

  const invalidateText = () => {
    axiosPrivate
      .put(`/texts/${textId}/admin-invalidate`)
      .then((res) => {
        dispatch(updateForm(res.data));
        dispatch(updateTextForm({ key: 'validated', value: false }));

        dispatch(
          updateTextOfTextList({
            id: textId,
            key: 'validated',
            value: false,
          })
        );
        setErrorSuccessMsg(`${t('Le statut du contenu a bien été modifié')}!`);
        setIsSuccess(true);
        setErrorSuccess(true);
      })
      .catch(() => {
        setIsFetchLoading(false);

        setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
        setIsSuccess(false);
        setErrorSuccess(true);
      });
  };

  return {
    invalidateText,
  };
};
